import { render, staticRenderFns } from "./TaskCreateSurvey.vue?vue&type=template&id=a36e19ea&scoped=true"
import script from "./TaskCreateSurvey.vue?vue&type=script&lang=js"
export * from "./TaskCreateSurvey.vue?vue&type=script&lang=js"
import style0 from "./TaskCreateSurvey.vue?vue&type=style&index=0&id=a36e19ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36e19ea",
  null
  
)

export default component.exports